
export const PersonalInfo = (props:any) => {
  return (
    <div className="outer-container">
    <div className="inner-container">
      <div className="info-container d-flex">
        <span className="tooltext">{props.name}</span>
      </div>
    </div>
    <div className="inner-container">
      <div className="info-container">
        <span className="tooltext">{props.email}</span>
      </div>
    </div>
    <div className="inner-container">
      <div className="info-container">
        <span className="tooltext">{props.phone}</span>
      </div>
    </div>
    <div className="inner-container">
      <div className="info-container">
        <span className="tooltext">{props.gender}</span>
      </div>
    </div>
  </div>
  )
}
